export default {
    breadcrumbs: {
        practice: 'Practice',
        practice_profile: 'Practice Profile',
        insurance_plans: 'Insurance Plans',
    },

    titles: {
        practice_members: '{practiceName} Members',
        insurance_plans_accepted: 'Insurance plans accepted',
    },

    buttons: {
        back_to_profile: 'Back to profile',
    },
}
